import { fotmatDateHeader } from "../../../../../global.d";
import { armarRow } from "../../minutaFood/services/serviceMinutaFood/serviceMinutaFood";
import { IEstructuraContrato, IPlanillaContrato } from "../../minutaVertical/serviceMinutaVertical/ServiceMinutaVertical";
import { headerMinutaHorizontal } from "../IMinutaHorizontal";

export const getOrderHeaderHorizontal = (dataHeader: headerMinutaHorizontal[]) => {
    let header: any = []
    dataHeader.forEach(item => {
        if (header[item.id_contrato] === undefined) {
            header[item.id_contrato] = [];
            header[item.id_contrato].push(
                {
                    text: 'Estructura servicios'
                }
            );
        }
        item.fecha = fotmatDateHeader(item.fecha)
        header[item.id_contrato].push(item);
    })
    return header;
}
export const nextService = (dataHeaderInit: any, position: any, dataHeader: any, setDataHeaderInit: any) => {
    const positionSelected = dataHeaderInit[position].slice(1);
    const lastDate = positionSelected.pop()?.fecha;
    if (lastDate) {
        let id = 0
        dataHeader.map((item2: any) => {
            item2.map((item: any, key: number) => {
                if (item.fecha === lastDate) id = key
            })
        })
        const ultimaFecha = id + 2;
        let dh = JSON.parse(JSON.stringify(dataHeader));
        dh = dh.slice(1);
        if (dh[position]) {
            const newRow = dh[position].slice(ultimaFecha - 7, ultimaFecha);
            newRow.unshift(dh[position][0]);
            dh[position] = newRow;
            dh.forEach((item: any, key: number) => {
                if (key !== position && item !== null) {
                    dh[key] = dataHeaderInit[key];
                }
            });
            setDataHeaderInit(dh);
        }
    }
}
export const backService = (dataHeaderInit: any, position: any, dataHeader: any, setDataHeaderInit: any) => {
    const positionSelected = dataHeaderInit[position];
    const lastDate = positionSelected[1]?.fecha;
    if (lastDate) {
        let id = 0
        dataHeader.map((item2: any) => {
            item2.map((item: any, key: number) => {
                if (item.fecha === lastDate) id = key
            })
        })
        const ultimaFecha = id - 1;
        let dh = JSON.parse(JSON.stringify(dataHeader));
        dh = dh.slice(1);
        if (dh[position] && ultimaFecha > 0) {
            const newRow = dh[position].slice(ultimaFecha, ultimaFecha + 7);
            newRow.unshift(dh[position][0]);
            dh.forEach((item: any, key: number) => {
                if (key !== position && item !== null) {
                    dh[key] = dataHeaderInit[key];
                }
            });
            dh[position] = newRow;
            setDataHeaderInit(dh);
        }
    }
}
export const getOrderRowHorizontal = (planillaContrato: any, estructuraContrato: any) => {
    const contratos = planillaContrato.reduce((acc: number[], item: IPlanillaContrato) => {
        if (!acc.includes(item.contrato)) {
            acc.push(item.contrato);
        }
        return acc;
    }, [])
    const dataPlanilla: any = []
    contratos.forEach((contrato: number, key: number) => {
        dataPlanilla[key] = [];
        dataPlanilla[key] = planillaContrato.filter((item: any) => item.contrato === contrato);
        dataPlanilla[key] = orderContract(
            planillaContrato.filter((item: any) => item.contrato === contrato),
            estructuraContrato.filter((item: any) => item.id_contrato === contrato)
        )
    });
    return dataPlanilla;
}
export const orderDataRow = (clumn: any, dataRow: any, structureSelected: any) => {
    clumn.forEach((it: any, k: number) => {
        if (k === 0) {
            it.showModal = true;
            it.id = k;
            it.key = "nombreEstructura";
            it.width = "100";
            it.value = k;
            it.classNameRow = 'clase-row-1'
        } else {
            it.id = k;
            it.key = "Nombretipoingprincipal" + k;
            it.show = false;
            it.showModalItem = true;
            it.text = it.fecha;
            it.value = k;
            it.classNameColum = "th-table th-table th-table clase-2 colum-fecha colum-fecha colum-fecha";
            it.classNameRow = "clase-row-2";
        }
    });
    const fechas = clumn.map((item: any) => { if (item.fecha) return item.fecha })
    const itemRow = armarDataRowHorizontal(fechas.slice(1, fechas.length), dataRow);
    const data: any[] = []
    const idStruct: any[] = []
    itemRow.forEach((item: any) => {
        if (!idStruct.includes(item.idEstructura)) {
            if (structureSelected.length === 0) {
                idStruct.push(item.idEstructura)
                data.push(
                    {
                        id: item.idEstructura,
                        nombre: item.nombreEstructura
                    }
                )
            } else {
                structureSelected.map((item2: number) => {
                    if (item.id_grupo_estructura === item2 && !idStruct.includes(item.idEstructura)) {
                        idStruct.push(item.idEstructura)
                        data.push(
                            {
                                id: item.idEstructura,
                                nombre: item.nombreEstructura
                            }
                        )
                    }
                })
            }
        }
    })
    const json = {
        columRow: data,
        dataRow: itemRow,
        header: fechas.slice(1, fechas.length)
    }
    return armarRow(json);

}
export const armarDataRowHorizontal = (fechas: string[], dataRow: any) => {
    const filterDataRow: any = [];
    dataRow.forEach((item: any, key: number) => {
        item.forEach((item2: any, key2: any) => {
            if (fechas.includes(item2.fecha)) {
                filterDataRow.push(item2);
            }
        });
    });
    return filterDataRow;
}
const orderContract = (planillaContrato: IPlanillaContrato[], estructuraContrato: IEstructuraContrato[]) => {
    let arrayEstructura: any = [];
    planillaContrato.forEach(item => {
        item.fecha = fotmatDateHeader(item.fecha);
        if (arrayEstructura[item.idEstructura] === undefined) {
            arrayEstructura[item.idEstructura] = [];
        }
        arrayEstructura[item.idEstructura].push(item);
    })
    return arrayEstructura;
}
